// App.js
import React, { createContext, useState } from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Product_Registration from './component/Product_Registration';
import Product_Reg_Details from './component/Product_Reg_Details';

// export const BASE_URL = 'http://localhost:81/grssuite/public/api';
// export const BASE_URL = 'https://mobile.cri.in/others/cri_retailer/public/api';
export const BASE_URL = 'https://apps.grssuite.com/api';
const App = () => {
    return (
        <div>
            {/*  <Router basename="/others/productregistration"> */}
            <Router basename="/"> 
                <Routes>
                    <Route path="/" element={<Product_Registration />} />
                    <Route path="/Registration_Details" element={<Product_Reg_Details />} />
                </Routes>
            </Router>
        </div>
    );
};

export default App;
